import { combineReducers } from "redux";
import optimist from "redux-optimist";
import { projectReducer } from "./projectReducer";
import { bucketReducer } from "./bucketReducer";
import { taskReducer } from "./taskReducer";
import { userReducer } from "./userReducer";
import { errorReducer } from "./errorReducer";
import { grid } from "./gridReducer";
import { dashboard } from "./dashboardReducer";
import { layoutReducer } from "./layoutReducer";
import { setting } from "./settingReducer";
import { ruleReducer } from "./ruleReducer";
import { notification } from "./notificationReducer";
import { tenant } from "./tenantReducer";
import { contact } from "./contactReducer";
import { goal } from "./goalReducer";
import { admin } from "./adminReducer";
import { labelReducer } from "./labelReducer";
import boardReducer from "../board/reducers/BoardReducer";
import { activityReducer } from "./activityReducer";
import { filterReducer } from "./filterReducer";
import { inboxReducer } from "./inboxReducer";
import { itemLinkReducer } from "./itemLinkReducer";
import { scoring } from "./itemScoringReducer";
import { template } from "./templateReducer";
import { report } from "./reportReducer";
import { reportSetting } from "./reportSettingReducer";
import { aiContentReducer } from "./aiContentReducer";
import { billingReducer } from "./billingReducer";

export default optimist(
  combineReducers({
    projectReducer,
    bucketReducer,
    taskReducer,
    grid,
    dashboard,
    errorReducer,
    layoutReducer,
    setting,
    userReducer,
    ruleReducer,
    notification,
    tenant,
    contact,
    goal,
    boardReducer,
    admin,
    labelReducer,
    activityReducer,
    filterReducer,
    inboxReducer,
    itemLinkReducer,
    scoring,
    template,
    report,
    reportSetting,
    aiContent: aiContentReducer,
    billingReducer,
  })
);
